<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <!-- <v-row> -->
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.go(-1)"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br/><br/>
        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text">{{ title }}</div>
            <br/>
            <v-row>
                <v-col cols="2" sm="3" class="suscritoVal" v-show="!suscrito && show == true">
                    <div class="descripcion">Actualmente no tienes una suscripción a débito automático.</div> 
                    <!-- <v-btn depressed color="success" style="margin-top: 10px;" @click="inscripcion = true;">
                      Suscribir
                    </v-btn> -->
                </v-col>
                <v-col cols="2" sm="3" class="suscritoVal" v-show="suscrito">
                    <div class="descripcion">¿Deseas ver la información de tu suscripción?</div> 
                    <v-btn depressed color="primary" class="btnValidar" @click="informacion = !informacion;">
                      Ver info
                    </v-btn>
                </v-col>
                <!-- <v-col cols="2" sm="3" style="display:flex; justify-content: center; flex-direction: column;" v-show="suscrito">
                    <div style="text-align: left; height: 48px;">¿Deseas actualizar los datos de tu suscripción?</div> 
                    <v-btn depressed color="warning" style="margin-top: 10px;" @click="actualizacion = !actualizacion;">
                      Actualizar
                    </v-btn>
                </v-col>-->
                <v-col cols="2" sm="3" class="suscritoVal" v-show="false">
                    <div class="descripcion">¿Deseas cancelar tu suscripción?</div> 
                    <v-btn depressed color="error" class="btnValidar">
                      Cancelar
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <!--
                <v-col cols="12" sm="6" v-show="inscripcion">
                    <v-alert id="mpLayer" border="left" colored-border color="#125ea5" elevation="2">
                        <h3 class="text-h5">
                            Nueva Subscripción
                        </h3>
                        
                        <form id="form-checkout" >
                            <input type="hidden" name="IDStB" id="IDStB" :value="this.user.IDStB">

                            <div class="form-group">
                                <label for="cardNumber" class="v-label theme--dark" >
                                    Número de la tarjeta
                                </label>
                                <input class="form-control" type="text" placeholder="XXXXXXXXXXXX" name="cardNumber" id="form-checkout__cardNumber" />
                            </div>

                            <div class="form-group">
                                <label for="cardExpirationDate" class="v-label theme--dark" >
                                    Fecha de vencimiento
                                </label>
                                <input class="form-control" type="text" placeholder="01/2022" name="cardExpirationDate" id="form-checkout__cardExpirationDate" />
                            </div>
                            
                            <div class="form-group">
                                <label for="cardholderName" class="v-label theme--dark" >
                                    Títular de la tarjeta
                                </label>
                                <input class="form-control" type="text" placeholder="John Doe" name="cardholderName" id="form-checkout__cardholderName"/>
                            </div>

                            <div class="form-group">
                                <label for="securityCode" class="v-label theme--dark" >
                                    Código de seguridad
                                </label>
                                <input class="form-control" type="text" placeholder="123" name="securityCode" id="form-checkout__securityCode" />
                            </div>
                            
                            <div class="form-group">
                                <label for="issuer" class="v-label theme--dark" >
                                    Emisor de tarjeta
                                </label>
                                <select class="form-control" name="issuer" id="form-checkout__issuer"></select>
                            </div>
                            
                            <div class="form-group">
                                <label for="identificationType" class="v-label theme--dark" >
                                    Tipo de identificación
                                </label>
                                <select class="form-control" name="identificationType" id="form-checkout__identificationType"></select>
                            </div>

                            <div class="form-group">
                                <label for="identificationNumber" class="v-label theme--dark" >
                                    Número de identificación
                                </label>
                                <input class="form-control" type="text" placeholder="12345678" name="identificationNumber" id="form-checkout__identificationNumber"/>
                            </div>

                            <div class="form-group">
                                <label for="installments" class="v-label theme--dark" >
                                    Número de cuotas
                                </label>
                                <select class="form-control" name="installments" id="form-checkout__installments"></select>
                            </div>
                            
                            <div style="width: 100%; text-align: center;">
                                <button type="submit" id="form-checkout__submit">Pagar</button>
                                <v-btn id="form-checkout__submit" type="submit" depressed color="primary">
                                    Subscribir
                                </v-btn>
                            </div>

                            <br><br>
                            <progress class="progress-bar" max="100" value="0"></progress>
                        </form>
                    </v-alert>
                </v-col>
                -->

                <v-col cols="12" sm="6" v-show="informacion">
                    <v-alert id="mpLayer_update" border="left" colored-border color="#125ea5" elevation="2">
                        <h3 class="text-h5">
                            Información de la Suscripción
                        </h3>
                        <!-- Step #2 -->
                        <div v-if="datosSuscripcion != null" style="margin-left: 15px;">

                            <div v-for="(item,index) in datosSuscripcion" :key="index" style="margin-bottom: 20px;">
                                
                                <v-subheader style="padding-left: 0px; height: 30px;">{{ item.reason }}</v-subheader>
                                <v-divider style="margin-bottom: 10px;"></v-divider>

                                <div class="infoSuscripcion">
                                    <strong class="infoSuscripcionDatos">Nombre del pagador:</strong>
                                    <div>
                                        {{ item.payer_first_name + " " + item.payer_last_name }}
                                    </div>
                                </div>

                                <div class="infoSuscripcion">
                                    <strong class="infoSuscripcionDatos">Método de pago usado:</strong>
                                    <div>
                                        {{ item.payment_method_id }}
                                    </div>
                                </div>

                                <div class="infoSuscripcion">
                                    <strong class="infoSuscripcionDatos">Estado de la sucripción:</strong>
                                    <div>
                                        {{ statusSuscripcion( item.status ) }}
                                    </div>
                                </div>

                                <div class="infoSuscripcion">
                                    <strong class="infoSuscripcionDatos">Estado del último pago:</strong>
                                    <div>
                                        {{ statusPago(item) }}
                                    </div>
                                </div>

                                <div class="infoSuscripcion">
                                    <strong class="infoSuscripcionDatos">Monto del último pago:</strong>
                                    <div>
                                        {{ showAMount(item) + " " + item.auto_recurring.currency_id }}
                                    </div>
                                </div>

                                <div v-if="item.summarized.last_charged_date != undefined" class="infoSuscripcion">
                                    <strong class="infoSuscripcionDatos">Fecha del último pago:</strong>
                                    <div>
                                        <div>
                                            {{ item.summarized.last_charged_date.split('T')[0] }}
                                        </div>
                                        
                                    </div>
                                </div>

                                <div v-if="item.next_payment_date != undefined" class="infoSuscripcion">
                                    <strong class="infoSuscripcionDatos">Fecha del siguiente pago:</strong>
                                    <div>
                                        {{ item.next_payment_date.split('T')[0] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div>Sin datos de suscripción.</div>
                        </div>
                    </v-alert>
                </v-col>

                <!--
                <v-col cols="12" sm="6" v-show="actualizacion">
                    <v-alert id="mpLayer_update" border="left" colored-border color="#db1d4a" elevation="2">
                        <h3 class="text-h5">
                            Actualizar Subscripción
                        </h3>
                        
                        <form id="form-checkout" >

                            <div class="form-group">
                                <label for="cardNumber2" class="v-label theme--dark" >
                                    Número de la tarjeta
                                </label>
                                <input class="form-control" type="text" placeholder="XXXXXXXXXXXX" name="cardNumber2" id="form-checkout__cardNumber2" />
                            </div>

                            <div class="form-group">
                                <label for="cardExpirationDate2" class="v-label theme--dark" >
                                    Fecha de vencimiento
                                </label>
                                <input class="form-control" type="text" placeholder="01/2022" name="cardExpirationDate2" id="form-checkout__cardExpirationDate2" />
                            </div>
                            
                            <div class="form-group">
                                <label for="cardholderName2" class="v-label theme--dark" >
                                    Títular de la tarjeta
                                </label>
                                <input class="form-control" type="text" placeholder="John Doe" name="cardholderName2" id="form-checkout__cardholderName2"/>
                            </div>

                            <div class="form-group">
                                <label for="securityCode2" class="v-label theme--dark" >
                                    Código de seguridad
                                </label>
                                <input class="form-control" type="text" placeholder="123" name="securityCode2" id="form-checkout__securityCode2" />
                            </div>
                            
                            <div class="form-group">
                                <label for="issuer2" class="v-label theme--dark" >
                                    Emisor de tarjeta
                                </label>
                                <select class="form-control" name="issuer2" id="form-checkout__issuer2"></select>
                            </div>
                            
                            <div class="form-group">
                                <label for="identificationType2" class="v-label theme--dark" >
                                    Tipo de identificación
                                </label>
                                <select class="form-control" name="identificationType2" id="form-checkout__identificationType2"></select>
                            </div>

                            <div class="form-group">
                                <label for="identificationNumber2" class="v-label theme--dark" >
                                    Número de identificación
                                </label>
                                <input class="form-control" type="text" placeholder="12345678" name="identificationNumber2" id="form-checkout__identificationNumber2"/>
                            </div>
                            
                            <div style="width: 100%; text-align: center;">
                                <v-btn id="form-checkout__submit2" type="submit" depressed color="primary" style="margin-bottom: 15px;">
                                    Actualizar
                                </v-btn>
                            </div>

                            <br><br>
                            <progress max="100" value="0"></progress>
                        </form>
                    </v-alert>
                </v-col>
                -->
            </v-row>
        </v-col>
      <!-- </v-row> -->
    </CardIeaAppMain>
  </div>
</template>

<!-- <style>

    #form-checkout{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    #form-checkout .form-group {
        margin-bottom: 1rem;
        width: 33%;
        flex-grow: 1;
        padding-left: 15px;
        padding-right: 15px;
    }

    #form-checkout .form-group label {
        display: inline-block;
        margin-bottom: 0.5rem;
        color:  #000;
    }

    #form-checkout label {
        display: inline-block;
        margin-bottom: 0.5rem;
    }

    #form-checkout .form-control {
        display: block;
        width: 100%;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }

    #form-checkout__submit{
        width: 200px;
        margin-bottom: 40px;
        margin-left: 15px;
        margin-right: 15px;
    }

    .text-h5{
        margin-bottom: 20px;
        margin-left: 15px;
        margin-right: 15px;    
    }

    /* All Progress Bars */
    progress {
        /* Reset the default appearance */
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        width: 100%;
        margin-left: 15px;
        margin-right: 15px;
    }

    /* Determinate */
    progress[value] {
        /* Reset the default appearance */
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }

    /* Indeterminate */
    progress:not([value]) {
        /* Reset the default appearance */
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }

    progress::-webkit-progress-bar {
        background: #EEE;
        box-shadow: 0 2px 3px rgba(0,0,0,0.2) inset;
        border-radius: 3px;
    }

    progress::-webkit-progress-value {
        background-color: #125ea5;
        border-radius: 3px;
    }

    progress {
        background: #EEE;
        box-shadow: 0 2px 3px rgba(0,0,0,0.2) inset;
        border-radius: 3px;
    }

    progress::-moz-progress-bar {
        background-color: #125ea5;
        border-radius: 3px;
    }

</style> -->

<script src="https://sdk.mercadopago.com/js/v2"></script>

<script>

// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
    name: "InformarPago",
    components: {
        // CardIeaApp,
        CardIeaAppMain,
    },

    data: () => ({
        title:"Mis Subscripciones",
        valid: false,
        cardholderName: '',
        lastname: '',
        cardNumber: '',
        inscripcion : false,
        actualizacion : false,
        informacion : false,
        suscrito : false,
        datosSuscripcion : null,
        nameRules: [
            v => !!v || 'cardNumber is required',
            v => v.length < 12 || 'card number must have 12 characters',
        ],
        show: false, 
    }),

    computed: {
        user() {
            return this.$store.getters.user;
        }
    },
    
    mounted() {
        if(this.$store.getters.user.borrado == 1 ||  this.$store.getters.user.alumno_mora ==  true){
          this.$router.push({
              name: "Home"
            });
        }
        const app = this;

        let url = "mp-detalle/subscripcion";
        let Wsdata = {
            alumno_id : app.user.IDStB,
        };

        this.$API
        .post({
            url : url,
            data : Wsdata,
        }).then((res) => {
            app.suscrito = res.hasSuscription;    
            app.datosSuscripcion = res.data; 
            this.show = true;       
        });

        // const mp = new MercadoPago('TEST-6afb0028-e527-47a0-a70e-1df05c7235d1');

        // console.log(this.user);

        // const cardForm = mp.cardForm({
        //     amount: "4980.00",
        //     autoMount: true,
            
        //     form: {
        //         id: "form-checkout",
        //         cardholderName: {
        //           id: "form-checkout__cardholderName",
        //           placeholder: "Titular de la tarjeta",
        //         },
        //         cardNumber: {
        //           id: "form-checkout__cardNumber",
        //           placeholder: "Número de la tarjeta",
        //         },
        //         cardExpirationDate: {
        //           id: "form-checkout__cardExpirationDate",
        //           placeholder: "MM/YYYY",
        //         },
        //         securityCode: {
        //           id: "form-checkout__securityCode",
        //           placeholder: "Código de seguridad",
        //         },
        //         installments: {
        //           id: "form-checkout__installments",
        //           placeholder: "Cuotas",
        //         },
        //         identificationType: {
        //           id: "form-checkout__identificationType",
        //           placeholder: "Tipo de documento",
        //         },
        //         identificationNumber: {
        //           id: "form-checkout__identificationNumber",
        //           placeholder: "Número de documento",
        //         },
        //         issuer: {
        //           id: "form-checkout__issuer",
        //           placeholder: "Banco emisor",
        //         },
        //     },
            
        //     callbacks: {
        //         onFormMounted: error => {
        //         if (error) return console.warn("Form Mounted handling error: ", error);
        //         // console.log("Form mounted");
        //         },

        //         onSubmit: event => {
        //             event.preventDefault();

        //             const {
        //                 paymentMethodId: payment_method_id,
        //                 issuerId: issuer_id,
        //                 cardholderEmail: email,
        //                 amount,
        //                 token,
        //                 installments,
        //                 identificationNumber,
        //                 identificationType,
        //             } = cardForm.getCardFormData();

        //             let dataSend = {
        //                 token,
        //                 issuer_id,
        //                 payment_method_id,
        //                 transaction_amount: Number(amount),
        //                 installments: Number(installments),
        //                 description: "Suscripción IEA",
        //                 payer: {
        //                     IDStB : document.querySelector("#IDStB").value,
        //                     identification: {
        //                         type: identificationType,
        //                         number: identificationNumber,
        //                     },
        //                 },
        //             };

        //             let url = "suscripcion/mercadopago";

        //             this.$API
        //             .post({
        //                 url: url,
        //                 data: dataSend
        //             }).then((res) => {
        //                 // console.log(res);                  
        //             });

        //             // fetch("/process_payment", {
        //             //     method: "POST",
        //             //     headers: {
        //             //         "Content-Type": "application/json",
        //             //     },
        //             //     body: JSON.stringify({
        //             //         token,
        //             //         issuer_id,
        //             //         payment_method_id,
        //             //         transaction_amount: Number(amount),
        //             //         installments: Number(installments),
        //             //         description: "Descripción del producto",
        //             //         payer: {
        //             //             email,
        //             //             identification: {
        //             //                 type: identificationType,
        //             //                 number: identificationNumber,
        //             //             },
        //             //         },
        //             //     }),
        //             // });
        //         },
                
        //         onFetching: (resource) => {
        //             // console.log("Fetching resource: ", resource);

        //             // Animate progress bar
        //             const progressBar = document.querySelector(".progress-bar");
        //             progressBar.removeAttribute("value");

        //             return () => {
        //                 progressBar.setAttribute("value", "0");
        //             };
        //         }
        //     },
        // });
    },

    methods: {
        statusPago(item){
            if(item.summarized.semaphore != undefined)
                switch (item.summarized.semaphore){
                    case 'green' : 
                        return 'Todos los cobros realizados.';
                    break;

                    case 'yellow' :
                        return "Con problemas de recaudación. Estamos tratando de cobrar una factura.";
                    break;

                    case 'red' :
                        return "Con cobros pendientes. No se pudo cobrar una factura.";
                    break;

                    case 'blank' :
                        return "Cobro con descuento.";
                    break;
                }
            else
                return 'Suscripción cancelada.';
        },
        statusSuscripcion(item){
            switch (item){
                case 'pending' : 
                    return 'Preaprobado sin método de pago.';
                break;

                case 'authorized' :
                    return "Aprobado."
                break;

                case 'paused' :
                    return "Aprobación previa, cobro de pagos interrumpido temporalmente."
                break;

                case 'cancelled' :
                    return "Cancelado."
                break;
            }
        },
        showAMount(item){

            var formatter = new Intl.NumberFormat('es-AR', {
              style: 'currency',
              currency: 'ARS',
            });

            if(item.summarized.last_charged_amount != undefined)
                return formatter.format(item.summarized.last_charged_amount);
            else
                return '$ 0 ARS';
        },
    }
};
</script>
